console.log("SLIM Configurator loading...");

// Hintamuutokset
const PRICE_ADJUSTMENTS = {
  euroAdjustment: 0,      // Euromääräinen lisäys/vähennys
  percentAdjustment: -10    // Prosentuaalinen lisäys/vähennys
};

// Määritä konfiguraatio
window.SlimProductConfig = {
  variantIds: {
    base: 51850462200146,
    adjustment: 51813495931218
  },
  dimensions: {
    minWidth: 200,
    maxWidth: 1500,
    minHeight: 200,
    maxHeight: 2500,
    maxArea: 2.6,
  },
  profiles: {
    white: { name: "Valkoinen RAL9016", color: "#FFFFFF" },
    silver: { name: "Hopea anodisoitu E6/EV1", color: "#EDEDED" },
    anthracite: { name: "Antrasiitti RAL7016 structure", color: "#3C3C3C" },
  },
  priceTable: {
    S: {
      700: {
        400: 123,
        500: 138,
        600: 152,
        700: 169,
        800: 184,
        900: 199,
        1000: 216,
        1100: 230,
        1200: 246,
        1300: 261,
        1400: 277,
      },
      800: {
        400: 125,
        500: 142,
        600: 157,
        700: 174,
        800: 189,
        900: 204,
        1000: 221,
        1100: 237,
        1200: 254,
        1300: 269,
        1400: 286,
      },
      900: {
        400: 127,
        500: 145,
        600: 160,
        700: 178,
        800: 194,
        900: 211,
        1000: 228,
        1100: 243,
        1200: 261,
        1300: 276,
        1400: 294,
      },
      1000: {
        400: 130,
        500: 148,
        600: 164,
        700: 182,
        800: 199,
        900: 216,
        1000: 234,
        1100: 251,
        1200: 269,
        1300: 285,
        1400: 303,
      },
      1100: {
        400: 133,
        500: 152,
        600: 168,
        700: 187,
        800: 204,
        900: 222,
        1000: 240,
        1100: 258,
        1200: 276,
        1300: 293,
        1400: 312,
      },
      1200: {
        400: 135,
        500: 154,
        600: 171,
        700: 191,
        800: 209,
        900: 227,
        1000: 246,
        1100: 264,
        1200: 283,
        1300: 300,
        1400: 321,
      },
      1300: {
        400: 137,
        500: 157,
        600: 175,
        700: 195,
        800: 214,
        900: 233,
        1000: 253,
        1100: 271,
        1200: 291,
        1300: 309,
        1400: 328,
      },
      1400: {
        400: 140,
        500: 160,
        600: 179,
        700: 200,
        800: 219,
        900: 238,
        1000: 258,
        1100: 279,
        1200: 299,
        1300: 317,
        1400: 337,
      },
      1500: {
        400: 142,
        500: 164,
        600: 183,
        700: 204,
        800: 223,
        900: 244,
        1000: 265,
        1100: 285,
        1200: 306,
        1300: 326,
        1400: 346,
      },
      1600: {
        400: 145,
        500: 167,
        600: 186,
        700: 208,
        800: 229,
        900: 249,
        1000: 272,
        1100: 292,
        1200: 313,
        1300: 333,
        1400: 355,
      },
      1700: {
        400: 148,
        500: 170,
        600: 190,
        700: 212,
        800: 233,
        900: 255,
        1000: 277,
        1100: 298,
        1200: 321,
        1300: 341,
        1400: 363,
      },
      1800: {
        400: 150,
        500: 172,
        600: 194,
        700: 216,
        800: 239,
        900: 260,
        1000: 284,
        1100: 306,
        1200: 328,
        1300: 350,
      },
      1900: {
        400: 152,
        500: 176,
        600: 197,
        700: 221,
        800: 243,
        900: 267,
        1000: 290,
        1100: 313,
        1200: 336,
        1300: 358,
      },
      2000: {
        400: 155,
        500: 179,
        600: 202,
        700: 225,
        800: 249,
        900: 272,
        1000: 296,
        1100: 319,
        1200: 344,
      },
      2100: {
        400: 158,
        500: 182,
        600: 205,
        700: 229,
        800: 254,
        900: 278,
        1000: 302,
        1100: 326,
        1200: 350,
      },
      2200: {
        400: 160,
        500: 186,
        600: 208,
        700: 234,
        800: 259,
        900: 283,
        1000: 309,
        1100: 332,
      },
      2300: {
        400: 162,
        500: 189,
        600: 213,
        700: 238,
        800: 264,
        900: 289,
        1000: 314,
        1100: 340,
      },
      2400: { 400: 165, 500: 192, 600: 218, 700: 242, 800: 268 },
      2500: { 400: 167, 500: 196, 600: 222, 700: 247, 800: 273 },
    },
    0: {
      700: {
        400: 125,
        500: 142,
        600: 156,
        700: 172,
        800: 188,
        900: 204,
        1000: 220,
        1100: 236,
        1200: 253,
        1300: 268,
        1400: 284,
      },
      800: {
        400: 127,
        500: 145,
        600: 160,
        700: 177,
        800: 194,
        900: 210,
        1000: 228,
        1100: 243,
        1200: 260,
        1300: 276,
        1400: 293,
      },
      900: {
        400: 130,
        500: 148,
        600: 164,
        700: 182,
        800: 199,
        900: 216,
        1000: 234,
        1100: 251,
        1200: 269,
        1300: 285,
        1400: 303,
      },
      1000: {
        400: 133,
        500: 152,
        600: 169,
        700: 187,
        800: 205,
        900: 223,
        1000: 241,
        1100: 259,
        1200: 278,
        1300: 294,
        1400: 313,
      },
      1100: {
        400: 136,
        500: 155,
        600: 172,
        700: 192,
        800: 210,
        900: 228,
        1000: 248,
        1100: 267,
        1200: 286,
        1300: 304,
        1400: 323,
      },
      1200: {
        400: 139,
        500: 158,
        600: 176,
        700: 197,
        800: 216,
        900: 235,
        1000: 255,
        1100: 274,
        1200: 294,
        1300: 313,
        1400: 333,
      },
      1300: {
        400: 141,
        500: 163,
        600: 181,
        700: 202,
        800: 221,
        900: 241,
        1000: 262,
        1100: 282,
        1200: 303,
        1300: 321,
        1400: 343,
      },
      1400: {
        400: 144,
        500: 166,
        600: 185,
        700: 206,
        800: 227,
        900: 248,
        1000: 269,
        1100: 290,
        1200: 311,
        1300: 330,
        1400: 352,
      },
      1500: {
        400: 147,
        500: 169,
        600: 190,
        700: 212,
        800: 232,
        900: 255,
        1000: 276,
        1100: 297,
        1200: 320,
        1300: 340,
        1400: 362,
      },
      1600: {
        400: 150,
        500: 172,
        600: 193,
        700: 216,
        800: 239,
        900: 260,
        1000: 284,
        1100: 305,
        1200: 327,
        1300: 349,
        1400: 372,
      },
      1700: {
        400: 152,
        500: 176,
        600: 197,
        700: 221,
        800: 244,
        900: 267,
        1000: 290,
        1100: 313,
        1200: 336,
        1300: 358,
        1400: 382,
      },
      1800: {
        400: 156,
        500: 179,
        600: 202,
        700: 226,
        800: 250,
        900: 272,
        1000: 297,
        1100: 320,
        1200: 345,
        1300: 367,
      },
      1900: {
        400: 158,
        500: 183,
        600: 206,
        700: 231,
        800: 255,
        900: 279,
        1000: 304,
        1100: 328,
        1200: 354,
        1300: 376,
      },
      2000: {
        400: 161,
        500: 187,
        600: 210,
        700: 236,
        800: 261,
        900: 285,
        1000: 311,
        1100: 336,
        1200: 361,
      },
      2100: {
        400: 163,
        500: 190,
        600: 215,
        700: 240,
        800: 266,
        900: 292,
        1000: 318,
        1100: 343,
        1200: 370,
      },
      2200: {
        400: 167,
        500: 193,
        600: 218,
        700: 246,
        800: 272,
        900: 299,
        1000: 325,
        1100: 351,
      },
      2300: {
        400: 169,
        500: 198,
        600: 222,
        700: 250,
        800: 277,
        900: 304,
        1000: 332,
        1100: 359,
      },
      2400: { 400: 171, 500: 203, 600: 226, 700: 254, 800: 282 },
      2500: { 400: 175, 500: 207, 600: 231, 700: 259, 800: 288 },
    },
    1: {
      700: {
        400: 130,
        500: 149,
        600: 164,
        700: 182,
        800: 200,
        900: 217,
        1000: 235,
        1100: 252,
        1200: 270,
        1300: 287,
        1400: 305,
      },
      800: {
        400: 134,
        500: 153,
        600: 171,
        700: 189,
        800: 207,
        900: 225,
        1000: 244,
        1100: 262,
        1200: 281,
        1300: 298,
        1400: 317,
      },
      900: {
        400: 138,
        500: 158,
        600: 176,
        700: 195,
        800: 215,
        900: 234,
        1000: 254,
        1100: 272,
        1200: 292,
        1300: 310,
        1400: 331,
      },
      1000: {
        400: 141,
        500: 163,
        600: 181,
        700: 202,
        800: 222,
        900: 241,
        1000: 263,
        1100: 283,
        1200: 303,
        1300: 322,
        1400: 344,
      },
      1100: {
        400: 146,
        500: 167,
        600: 186,
        700: 209,
        800: 230,
        900: 250,
        1000: 272,
        1100: 293,
        1200: 314,
        1300: 334,
        1400: 356,
      },
      1200: {
        400: 149,
        500: 171,
        600: 192,
        700: 215,
        800: 237,
        900: 258,
        1000: 281,
        1100: 303,
        1200: 325,
        1300: 345,
        1400: 369,
      },
      1300: {
        400: 151,
        500: 176,
        600: 198,
        700: 222,
        800: 244,
        900: 267,
        1000: 290,
        1100: 313,
        1200: 336,
        1300: 358,
        1400: 381,
      },
      1400: {
        400: 156,
        500: 180,
        600: 203,
        700: 228,
        800: 251,
        900: 274,
        1000: 299,
        1100: 322,
        1200: 347,
        1300: 370,
        1400: 394,
      },
      1500: {
        400: 163,
        500: 186,
        600: 208,
        700: 234,
        800: 259,
        900: 283,
        1000: 309,
        1100: 333,
        1200: 358,
        1300: 382,
        1400: 407,
      },
      1600: {
        400: 168,
        500: 190,
        600: 214,
        700: 240,
        800: 266,
        900: 291,
        1000: 318,
        1100: 342,
        1200: 369,
        1300: 394,
        1400: 420,
      },
      1700: {
        400: 168,
        500: 194,
        600: 219,
        700: 247,
        800: 273,
        900: 300,
        1000: 326,
        1100: 353,
        1200: 380,
        1300: 406,
        1400: 433,
      },
      1800: {
        400: 171,
        500: 199,
        600: 226,
        700: 254,
        800: 280,
        900: 307,
        1000: 336,
        1100: 363,
        1200: 391,
        1300: 418,
      },
      1900: {
        400: 174,
        500: 203,
        600: 230,
        700: 259,
        800: 287,
        900: 316,
        1000: 345,
        1100: 373,
        1200: 402,
        1300: 429,
      },
      2000: {
        400: 178,
        500: 208,
        600: 236,
        700: 266,
        800: 295,
        900: 324,
        1000: 354,
        1100: 383,
        1200: 413,
      },
      2100: {
        400: 182,
        500: 213,
        600: 241,
        700: 272,
        800: 302,
        900: 333,
        1000: 364,
        1100: 393,
        1200: 424,
      },
      2200: {
        400: 185,
        500: 217,
        600: 247,
        700: 279,
        800: 310,
        900: 340,
        1000: 372,
        1100: 403,
      },
      2300: {
        400: 189,
        500: 222,
        600: 252,
        700: 285,
        800: 317,
        900: 349,
        1000: 381,
        1100: 414,
      },
      2400: { 400: 193, 500: 227, 600: 257, 700: 291, 800: 323 },
      2500: { 400: 197, 500: 232, 600: 263, 700: 298, 800: 331 },
    },
    2: {
      700: {
        400: 138,
        500: 158,
        600: 176,
        700: 195,
        800: 215,
        900: 234,
        1000: 254,
        1100: 273,
        1200: 293,
        1300: 311,
        1400: 332,
      },
      800: {
        400: 142,
        500: 164,
        600: 183,
        700: 204,
        800: 224,
        900: 245,
        1000: 266,
        1100: 286,
        1200: 308,
        1300: 327,
        1400: 347,
      },
      900: {
        400: 150,
        500: 170,
        600: 191,
        700: 213,
        800: 233,
        900: 256,
        1000: 278,
        1100: 299,
        1200: 322,
        1300: 342,
        1400: 365,
      },
      1000: {
        400: 152,
        500: 176,
        600: 197,
        700: 221,
        800: 243,
        900: 266,
        1000: 289,
        1100: 312,
        1200: 336,
        1300: 358,
        1400: 381,
      },
      1100: {
        400: 157,
        500: 182,
        600: 203,
        700: 229,
        800: 253,
        900: 277,
        1000: 301,
        1100: 325,
        1200: 349,
        1300: 373,
        1400: 397,
      },
      1200: {
        400: 162,
        500: 188,
        600: 211,
        700: 237,
        800: 262,
        900: 288,
        1000: 313,
        1100: 338,
        1200: 364,
        1300: 388,
        1400: 414,
      },
      1300: {
        400: 167,
        500: 193,
        600: 219,
        700: 246,
        800: 272,
        900: 297,
        1000: 325,
        1100: 351,
        1200: 378,
        1300: 403,
        1400: 430,
      },
      1400: {
        400: 171,
        500: 200,
        600: 226,
        700: 254,
        800: 282,
        900: 308,
        1000: 336,
        1100: 364,
        1200: 392,
        1300: 418,
        1400: 447,
      },
      1500: {
        400: 181,
        500: 205,
        600: 232,
        700: 262,
        800: 290,
        900: 319,
        1000: 348,
        1100: 377,
        1200: 406,
        1300: 434,
        1400: 463,
      },
      1600: {
        400: 181,
        500: 211,
        600: 240,
        700: 270,
        800: 300,
        900: 330,
        1000: 360,
        1100: 389,
        1200: 421,
        1300: 450,
        1400: 480,
      },
      1700: {
        400: 185,
        500: 217,
        600: 247,
        700: 279,
        800: 309,
        900: 340,
        1000: 372,
        1100: 403,
        1200: 435,
        1300: 465,
        1400: 496,
      },
      1800: {
        400: 190,
        500: 223,
        600: 254,
        700: 287,
        800: 319,
        900: 351,
        1000: 383,
        1100: 416,
        1200: 449,
        1300: 480,
      },
      1900: {
        400: 195,
        500: 230,
        600: 261,
        700: 295,
        800: 329,
        900: 362,
        1000: 395,
        1100: 429,
        1200: 463,
        1300: 496,
      },
      2000: {
        400: 199,
        500: 235,
        600: 269,
        700: 303,
        800: 338,
        900: 372,
        1000: 408,
        1100: 442,
        1200: 478,
      },
      2100: {
        400: 204,
        500: 241,
        600: 275,
        700: 312,
        800: 347,
        900: 383,
        1000: 420,
        1100: 455,
        1200: 491,
      },
      2200: {
        400: 209,
        500: 247,
        600: 282,
        700: 321,
        800: 356,
        900: 394,
        1000: 432,
        1100: 467,
      },
      2300: {
        400: 214,
        500: 253,
        600: 289,
        700: 328,
        800: 366,
        900: 404,
        1000: 443,
        1100: 480,
      },
      2400: { 400: 219, 500: 259, 600: 296, 700: 335, 800: 376 },
      2500: { 400: 224, 500: 265, 600: 304, 700: 343, 800: 385 },
    },
    3: {
      700: {
        400: 150,
        500: 174,
        600: 194,
        700: 217,
        800: 239,
        900: 261,
        1000: 285,
        1100: 306,
        1200: 329,
        1300: 350,
        1400: 373,
      },
      800: {
        400: 157,
        500: 181,
        600: 204,
        700: 228,
        800: 252,
        900: 275,
        1000: 300,
        1100: 324,
        1200: 348,
        1300: 372,
        1400: 395,
      },
      900: {
        400: 163,
        500: 189,
        600: 214,
        700: 239,
        800: 265,
        900: 291,
        1000: 316,
        1100: 341,
        1200: 368,
        1300: 394,
        1400: 418,
      },
      1000: {
        400: 170,
        500: 198,
        600: 224,
        700: 251,
        800: 278,
        900: 305,
        1000: 333,
        1100: 360,
        1200: 388,
        1300: 413,
        1400: 441,
      },
      1100: {
        400: 176,
        500: 205,
        600: 232,
        700: 262,
        800: 291,
        900: 319,
        1000: 348,
        1100: 377,
        1200: 406,
        1300: 434,
        1400: 463,
      },
      1200: {
        400: 183,
        500: 213,
        600: 242,
        700: 273,
        800: 303,
        900: 334,
        1000: 365,
        1100: 395,
        1200: 426,
        1300: 455,
        1400: 486,
      },
      1300: {
        400: 189,
        500: 222,
        600: 252,
        700: 285,
        800: 317,
        900: 348,
        1000: 381,
        1100: 412,
        1200: 445,
        1300: 476,
        1400: 508,
      },
      1400: {
        400: 195,
        500: 230,
        600: 262,
        700: 296,
        800: 329,
        900: 362,
        1000: 397,
        1100: 430,
        1200: 464,
        1300: 497,
        1400: 531,
      },
      1500: {
        400: 208,
        500: 238,
        600: 272,
        700: 307,
        800: 342,
        900: 378,
        1000: 413,
        1100: 449,
        1200: 484,
        1300: 518,
        1400: 553,
      },
      1600: {
        400: 208,
        500: 246,
        600: 281,
        700: 318,
        800: 355,
        900: 392,
        1000: 430,
        1100: 465,
        1200: 503,
        1300: 539,
        1400: 576,
      },
      1700: {
        400: 215,
        500: 254,
        600: 290,
        700: 329,
        800: 368,
        900: 406,
        1000: 445,
        1100: 484,
        1200: 523,
        1300: 559,
        1400: 599,
      },
      1800: {
        400: 220,
        500: 261,
        600: 300,
        700: 341,
        800: 381,
        900: 420,
        1000: 461,
        1100: 501,
        1200: 541,
        1300: 580,
      },
      1900: {
        400: 227,
        500: 270,
        600: 310,
        700: 352,
        800: 393,
        900: 436,
        1000: 478,
        1100: 519,
        1200: 561,
        1300: 601,
      },
      2000: {
        400: 234,
        500: 278,
        600: 320,
        700: 363,
        800: 407,
        900: 450,
        1000: 493,
        1100: 536,
        1200: 581,
      },
      2100: {
        400: 240,
        500: 287,
        600: 329,
        700: 375,
        800: 420,
        900: 464,
        1000: 510,
        1100: 554,
        1200: 599,
      },
      2200: {
        400: 247,
        500: 294,
        600: 339,
        700: 386,
        800: 436,
        900: 478,
        1000: 526,
        1100: 572,
      },
      2300: {
        400: 253,
        500: 302,
        600: 349,
        700: 397,
        800: 445,
        900: 493,
        1000: 541,
        1100: 589,
      },
      2400: { 400: 259, 500: 310, 600: 359, 700: 408, 800: 456 },
      2500: { 400: 266, 500: 318, 600: 369, 700: 420, 800: 471 },
    },
  },
};

document.addEventListener("DOMContentLoaded", function () {
  const config = window.SlimProductConfig;
  let selectedFabricGroup = null;
  let selectedProfile = null;
  let widthInput, heightInput, profileStep, priceDisplay, calculatedPrice;

  // Piilota alkuperäinen ostoskoriin-nappi heti
  setTimeout(function () {
    const originalButton = document.querySelector('button[name="add"]');

    if (originalButton) {
      originalButton.style.position = "absolute";
      originalButton.style.left = "-9999px";
      originalButton.style.visibility = "hidden";
      console.log("Original button hidden on page load");
    }
  }, 100);

  // Odota että DOM on valmis, sitten luo elementit
  setTimeout(function () {
    console.log("Calling createSlimElements...");
    createSlimElements();

    // Tunnista oletuskangasväri sivun latautuessa
    const fabricSelect = document.querySelector(
      'select[name="options[KANGAS]"]'
    );
    if (fabricSelect && fabricSelect.selectedIndex >= 0) {
      const selectedOption = fabricSelect.options[fabricSelect.selectedIndex];
      const variantTitle = selectedOption.text;
      const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
      if (groupMatch) {
        selectedFabricGroup = groupMatch[1];
        console.log("Initial fabric group detected:", selectedFabricGroup);

        if (profileStep) {
          profileStep.classList.remove("disabled");
          profileStep.classList.add("active");
          createProfileOptions();
        }
      }
    }

    // Kangasvärin valinta
    if (fabricSelect) {
      fabricSelect.addEventListener("change", function () {
        const selectedOption = this.options[this.selectedIndex];
        const variantTitle = selectedOption.text;

        const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
        if (groupMatch) {
          selectedFabricGroup = groupMatch[1];
          console.log("Selected fabric group:", selectedFabricGroup);

          if (profileStep) {
            profileStep.classList.remove("disabled");
            profileStep.classList.add("active");
            createProfileOptions();
          }
          calculatePrice();
        }
      });
    }
  }, 300);

  function createSlimElements() {
  const productForm =
    document.querySelector(".product-form") ||
    document.querySelector(".product__info-wrapper") ||
    document.body;

  // Luo pääkontaineri
  let configurator = document.getElementById("slim-configurator");
  if (!configurator) {
    configurator = document.createElement("div");
    configurator.id = "slimm-configurator";
    configurator.className = "slim-configurator";
    productForm.appendChild(configurator);
  }

    // Luo mittakentät
    if (!document.getElementById("width-input")) {
      const dimensionsDiv = document.createElement("div");
      dimensionsDiv.className = "config-step active";

      dimensionsDiv.innerHTML = `
            <h3>Syötä mitat (mm)</h3>
            <div class="dimension-inputs">
                <div class="input-group">
                    <label>Leveys</label>
                    <input placeholder="esim. 700" max="1500" min="200" id="width-input" type="number">
                    <div id="width-validation" class="validation-message"></div>
                </div>
                <div class="input-group">
                    <label>Korkeus</label>
                    <input placeholder="esim. 1200" max="2500" min="200" id="height-input" type="number">
                    <div id="height-validation" class="validation-message"></div>
                </div>
            </div>
        `;

      configurator.appendChild(dimensionsDiv);
    }

    // Luo profiiliväri-osio
    if (!document.getElementById("profile-step")) {
      const profileDiv = document.createElement("div");
      profileDiv.id = "profile-step";
      profileDiv.className = "config-step disabled";
      profileDiv.innerHTML = `
            <h3>Valitse profiiliväri</h3>
            <div id="profile-options"></div>
        `;
      configurator.appendChild(profileDiv);
    }

    // Luo hinta-osio
    if (!document.getElementById("price-display")) {
      const priceDiv = document.createElement("div");
      priceDiv.id = "price-display";
      priceDiv.className = "config-step price-display";
      priceDiv.style.display = "none";
      priceDiv.innerHTML = `
            <h3>Hinta</h3>
            <div style="font-size: 2rem; font-weight: bold; color: #ffffff; margin-bottom: 15px;" id="calculated-price"></div>
        `;
      configurator.appendChild(priceDiv);
    }

    // Päivitä elementtiviittaukset
    widthInput = document.getElementById("width-input");
    heightInput = document.getElementById("height-input");
    profileStep = document.getElementById("profile-step");
    priceDisplay = document.getElementById("price-display");
    calculatedPrice = document.getElementById("calculated-price");
  }

  function getProfilesForProduct() {
    const productHandle = window.location.pathname;

    // Jos ALL-BLACK tai MUSTA tuote - vain musta profiili
    if (
      productHandle.includes("all-black") ||
      productHandle.includes("musta")
    ) {
      return {
        anthracite: {
          name: "Musta RAL9005 structure",
          color: "#0A0A0A",
        },
      };
    }

    // Muuten kaikki normaalit BASIC profiilit
    return config.profiles;
  }

  function createProfileOptions() {
    const profileOptions = document.getElementById("profile-options");
    if (!profileOptions) return;

    const customDropdown = document.createElement("div");
    customDropdown.className = "custom-dropdown";

    const selected = document.createElement("div");
    selected.className = "dropdown-selected";

    selected.innerHTML = `
    <span>Valitse profiiliväri</span>
    <span class="dropdown-arrow">▼</span>
`;

    const options = document.createElement("div");
    options.className = "dropdown-options";

    // Lisää profiilivärit
    Object.keys(getProfilesForProduct()).forEach(function (key) {
      const profile = getProfilesForProduct()[key];

      const option = document.createElement("div");
      option.className = "dropdown-option";

      option.innerHTML = `
    <span class="profile-color-icon" style="background-color: ${profile.color};"></span>
    <span class="profile-option-text">${profile.name}</span>
  `;

      option.addEventListener("click", function () {
        selectedProfile = key;
        selected.innerHTML = `
      <span class="dropdown-selected-content">
        <span class="profile-color-icon" style="background-color: ${profile.color};"></span>
        ${profile.name}
      </span>
      <span class="dropdown-arrow">▼</span>
    `;

        options.classList.remove("show");
        calculatePrice();
      });

      options.appendChild(option);
    });

    selected.addEventListener("click", function () {
      options.classList.toggle("show");
    });

    customDropdown.appendChild(selected);
    customDropdown.appendChild(options);

    profileOptions.innerHTML = "";
    profileOptions.appendChild(customDropdown);
  }

  function calculatePrice() {
    console.log("calculatePrice called");
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    // Tarkista validointi ensin
    if (!updateFieldValidation()) {
      console.log("Validation failed");
      // Näytä lähtöhinta vaikka validointi epäonnistui (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 130.00 €";
      return;
    }

    // Tarkista että profiiliväri on valittu
    if (!selectedProfile) {
      console.log("No profile selected");
      // Näytä lähtöhinta vaikka profiilia ei valittu (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 130.00 €";
      return;
    }

    console.log("Current values:", {
      width: width,
      height: height,
      selectedFabricGroup: selectedFabricGroup,
      selectedProfile: selectedProfile,
    });

    if (
      width > 0 &&
      height > 0 &&
      selectedFabricGroup &&
      config.priceTable[selectedFabricGroup]
    ) {
      const normalizedWidth = Math.min(
        Math.max(Math.ceil(width / 100) * 100, 400),
        1400
      );
      const normalizedHeight = Math.min(
        Math.max(Math.ceil(height / 100) * 100, 700),
        2400
      );

      console.log(
        "Normalized dimensions:",
        normalizedWidth,
        "x",
        normalizedHeight
      );

      const priceData = config.priceTable[selectedFabricGroup];
      let basePrice = null;

      if (priceData[normalizedHeight]) {
        if (priceData[normalizedHeight][normalizedWidth]) {
          basePrice = priceData[normalizedHeight][normalizedWidth];
          console.log("Price found:", basePrice);
        } else {
          // B-hinnoittelu: etsi lähin pienempi leveys
          for (let w = normalizedWidth - 100; w >= 400; w -= 100) {
            if (priceData[normalizedHeight][w]) {
              basePrice = priceData[normalizedHeight][w];
              console.log("B-pricing: Found price", basePrice, "at width", w);
              break;
            }
          }
          if (!basePrice) basePrice = 130.0;
        }
      } else {
        // B-hinnoittelu: etsi lähin pienempi korkeus
        for (let h = normalizedHeight - 100; h >= 700; h -= 100) {
          if (priceData[h] && priceData[h][normalizedWidth]) {
            basePrice = priceData[h][normalizedWidth];
            console.log("B-pricing: Found price", basePrice, "at height", h);
            break;
          }
        }
        if (!basePrice) basePrice = 130.0;
      }

      if (calculatedPrice && basePrice) {
        // 1. Lisää euromääräinen muutos
        let priceAfterEuro = basePrice + PRICE_ADJUSTMENTS.euroAdjustment;
        console.log("After euro adjustment:", priceAfterEuro);
        
        // 2. Lisää prosentuaalinen muutos
        let priceAfterPercent = priceAfterEuro * (1 + PRICE_ADJUSTMENTS.percentAdjustment / 100);
        console.log("After percent adjustment:", priceAfterPercent);
        
        // 3. Pyöristä lähimpään tasaeuroon
        let roundedPrice = Math.round(priceAfterPercent);
        console.log("After rounding:", roundedPrice);
        
        // 4. Varmista minimihinta 130 €
        const finalPrice = Math.max(roundedPrice, 130);
        console.log("Final price:", finalPrice);
        
        calculatedPrice.textContent = finalPrice.toFixed(2) + " €";
      }
      if (priceDisplay) {
        priceDisplay.style.display = "block";
      }

      // Lisää ostoskoriin-nappi
      createAddToCartButton();
    } else {
      console.log("Conditions not met for price calculation");
      if (priceDisplay) priceDisplay.style.display = "none";
    }
  }

  function validateDimensions(width, height) {
    const errors = {};
    const messages = {};

    if (width < 200) {
      errors.width = true;
      messages.width = "Min 200mm";
    } else if (width > 1500) {
      errors.width = true;
      messages.width = "Max 1500mm";
    }

    if (height < 200) {
      errors.height = true;
      messages.height = "Min 200mm";
    } else if (height > 2500) {
      errors.height = true;
      messages.height = "Max 2500mm";
    }

    if (width * height > 2600000) {
      errors.width = true;
      errors.height = true;
      messages.width = "Max 2,6 m²";
      messages.height = "Max 2,6 m²";
    }

    if (width >= 801 && width <= 1200 && height > 2200) {
      errors.height = true;
      messages.height = "Max 2200mm";
    }
    if (width >= 1201 && width <= 1500 && height > 1600) {
      errors.height = true;
      messages.height = "Max 1600mm";
    }

    return { errors, messages };
  }

  function updateFieldValidation() {
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    if (width > 0 && height > 0) {
      const validation = validateDimensions(width, height);

      // Käytä CSS-luokkia inline-tyylien sijaan
      const widthValidation = document.getElementById("width-validation");
      const heightValidation = document.getElementById("height-validation");

      if (validation.errors.width) {
        widthInput.style.borderColor = "#ff6b6b";
        if (widthValidation) {
          widthValidation.textContent = validation.messages.width;
          widthValidation.className = "validation-message error";
        }
      } else {
        widthInput.style.borderColor = "#333";
        if (widthValidation) {
          widthValidation.textContent = "";
          widthValidation.className = "validation-message";
        }
      }

      if (validation.errors.height) {
        heightInput.style.borderColor = "#ff6b6b";
        if (heightValidation) {
          heightValidation.textContent = validation.messages.height;
          heightValidation.className = "validation-message error";
        }
      } else {
        heightInput.style.borderColor = "#333";
        if (heightValidation) {
          heightValidation.textContent = "";
          heightValidation.className = "validation-message";
        }
      }

      if (validation.errors.width || validation.errors.height) {
        if (priceDisplay) priceDisplay.style.display = "none";
        return false;
      }
    }

    return true;
  }

  function createAddToCartButton() {
  // Tarkista onko nappi jo olemassa
  let existingButton = document.getElementById("slim-add-to-cart");
  if (existingButton) {
    existingButton.style.display = "block";
    return;
  }

  // Luo uusi nappi
  const addToCartButton = document.createElement("button");
  addToCartButton.id = "slim-add-to-cart";
  addToCartButton.type = "button";
  addToCartButton.textContent = "Lisää ostoskoriin";
  addToCartButton.className = "slim-add-to-cart-button";

  // UUSI: Cart API -pohjainen lisäys
  addToCartButton.addEventListener("click", function () {
    // Kerää tiedot
    const width = parseInt(widthInput.value);
    const height = parseInt(heightInput.value);
    const calculatedPriceValue = parseFloat(calculatedPrice.textContent.replace(' €', '').replace(',', '.'));
    const profileName = getProfilesForProduct()[selectedProfile].name;
    
    // Hae kangasväri
    const fabricSelect = document.querySelector('select[name="options[KANGAS]"]');
    const fabricOption = fabricSelect ? fabricSelect.options[fabricSelect.selectedIndex].text : 'Ei valittu';
    
    // Perustuotteen hinta
    const basePrice = 129.00;
    
    // Laske korotus
    const priceAdjustment = calculatedPriceValue - basePrice;
    
    // Luo unique ID tälle tuoteparille
    const pairId = Date.now().toString();
    
    // Valmistele Cart API -kutsu (käänteisessä järjestyksessä)
    const formData = {
      items: []
    };
    
    // Lisää räätälöinti AINA (jos hinta > 0)
    const adjustmentQuantity = Math.max(1, Math.round(priceAdjustment));
    
    formData.items.push({
      id: config.variantIds.adjustment,
      quantity: adjustmentQuantity,
      properties: {
        'Kangasväri': fabricOption,
        'Mitat': `${width}×${height} mm`,
        'Profiiliväri': profileName,
        '_pair_id': pairId,
        '_pair_order': '2'
      }
    });
    
    // Lisää perustuote TOISENA
    formData.items.push({
      id: config.variantIds.base,
      quantity: 1,
      properties: {
        '_pair_id': pairId,
        '_pair_order': '1'
      }
    });
    
    // Lähetä Cart API:lle
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
      // Päivitä ostoskori
      window.location.href = '/cart';
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('Lisääminen ostoskoriin epäonnistui. Yritä uudelleen.');
    });
  });

  // Lisää hinta-osion jälkeen
  if (priceDisplay) {
    priceDisplay.appendChild(addToCartButton);
  }
  
  console.log("Add to cart button created");
}

  // Varmista hinnan päivitys kaikissa tilanteissa
  let lastValues = {
    width: "",
    height: "",
    fabric: "",
    profile: "",
  };

  function checkForChanges() {
    const currentWidth = widthInput?.value || "";
    const currentHeight = heightInput?.value || "";
    const currentFabric =
      document.querySelector('select[name="options[KANGAS]"]')?.value || "";
    const currentProfile = selectedProfile || "";

    if (
      currentWidth !== lastValues.width ||
      currentHeight !== lastValues.height ||
      currentFabric !== lastValues.fabric ||
      currentProfile !== lastValues.profile
    ) {
      console.log("Change detected, updating price...");

      // Päivitä kangasryhmä jos tarpeen
      if (currentFabric !== lastValues.fabric) {
        const fabricSelect = document.querySelector(
          'select[name="options[KANGAS]"]'
        );
        if (fabricSelect) {
          const selectedOption =
            fabricSelect.options[fabricSelect.selectedIndex];
          const variantTitle = selectedOption.text;
          const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
          if (groupMatch) {
            selectedFabricGroup = groupMatch[1];
            console.log("Updated fabric group:", selectedFabricGroup);
          }
        }
      }

      calculatePrice();

      lastValues.width = currentWidth;
      lastValues.height = currentHeight;
      lastValues.fabric = currentFabric;
      lastValues.profile = currentProfile;
    }
  }

  function updateAreaDisplay(width, height) {
    console.log("updateAreaDisplay called with:", width, height);

    const areaValueElement = document.getElementById("area-value");
    const areaDisplayElement = document.getElementById("area-display");

    console.log("Area value element:", areaValueElement);
    console.log("Area display element:", areaDisplayElement);

    if (!areaValueElement) {
      console.log("ERROR: area-value element not found!");
      return;
    }

    if (width > 0 && height > 0) {
      const area = ((width * height) / 1000000).toFixed(2);
      console.log("Calculated area:", area);

      areaValueElement.textContent = area + " m²";
      console.log("Area text updated to:", areaValueElement.textContent);

      // Muuta väri jos ylittää 2,6 m²
      if (parseFloat(area) > 2.6) {
        areaValueElement.style.color = "red";
        console.log("Area color set to red");
      } else {
        areaValueElement.style.color = "#dfa408";
        console.log("Area color set to green");
      }
    } else {
      areaValueElement.textContent = "- m²";
      areaValueElement.style.color = "white";
      console.log("Area reset to default");
    }
  }

  // Tarkista muutokset 500ms välein
  setInterval(checkForChanges, 500);
});
